export default {
  roleAdmin: 'quản lý quyền hạn',
  roleList: ' danh sách quyền hạn',
  roleCoding: '  mã quyền hạn',
  roleName: ' tên quyền hạn',
  roleId: 'quyền hạn ID',
  selectroleId: ' chọn quyền hạn ID',
  creator: ' người tạo',
  Remarks: ' ghi chú',
  modiFicaTion: ' sửa đổi',
  View: ' xem',
  compileRole: ' chỉnh sửa quyền hạn',
  inputNull: ' tìm kiếm không được để trống',
  addRole: ' thêm quyền hạn',
  checkRole: ' xem quyền hạn',
  deviceInfo: 'Thông tin thiết bị',
  data: {
    roleCode: ' vui lòng nhập mã quyền hạn',
    roleName: ' vui lòng nhập tên người dùng',
    distributedId: ' vui lòng chọn phân bổ ID',
    addRoleError: ' thêm quyền hạn thất bại',
    changRoleError: ' sửa đổi quyền hạn thất bại'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/rolemanager.js